/* tslint:disable */
/* eslint-disable */
/**
 * WICSSend
 * API reference documentation for WICSSend
 *
 * The version of the OpenAPI document: 0.1.0-RC
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Onboard } from '../model';
// @ts-ignore
import type { OnboardResponse } from '../model';
/**
 * OnboardApi - axios parameter creator
 * @export
 */
export const OnboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Onboard} [onboard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppOnboardingOnboard: async (onboard?: Onboard, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/onboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboard, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardApi - functional programming interface
 * @export
 */
export const OnboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Onboard} [onboard] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAppOnboardingOnboard(onboard?: Onboard, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAppOnboardingOnboard(onboard, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardApi.postAppOnboardingOnboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardApi - factory interface
 * @export
 */
export const OnboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardApiFp(configuration)
    return {
        /**
         * 
         * @param {OnboardApiPostAppOnboardingOnboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAppOnboardingOnboard(requestParameters: OnboardApiPostAppOnboardingOnboardRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OnboardResponse> {
            return localVarFp.postAppOnboardingOnboard(requestParameters.onboard, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for postAppOnboardingOnboard operation in OnboardApi.
 * @export
 * @interface OnboardApiPostAppOnboardingOnboardRequest
 */
export interface OnboardApiPostAppOnboardingOnboardRequest {
    /**
     * 
     * @type {Onboard}
     * @memberof OnboardApiPostAppOnboardingOnboard
     */
    readonly onboard?: Onboard
}

/**
 * OnboardApi - object-oriented interface
 * @export
 * @class OnboardApi
 * @extends {BaseAPI}
 */
export class OnboardApi extends BaseAPI {
    /**
     * 
     * @param {OnboardApiPostAppOnboardingOnboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardApi
     */
    public postAppOnboardingOnboard(requestParameters: OnboardApiPostAppOnboardingOnboardRequest = {}, options?: RawAxiosRequestConfig) {
        return OnboardApiFp(this.configuration).postAppOnboardingOnboard(requestParameters.onboard, options).then((request) => request(this.axios, this.basePath));
    }
}

